export default "__VITE_ASSET__Dud7MgBt__"